export default __webpack_public_path__ + "static/media/check.2bdbc30f.svg";